import { reduxKey } from './constants';

export interface ModerationState {
  deviations: {
    [deviationId: number]: {
      authorUserId?: number;
      isBlocked: boolean;
    };
  };
  users: {
    [userId: number]: {
      isBlocked: boolean;
    };
  };
}

export interface ModerationStoreSlice {
  [reduxKey]?: ModerationState;
}

export enum BlockReasons {
  /** deviation is marked as mature and the user has the mature filter enabled */
  MatureFilter = 'mature_filter',
  /** deviation is marked as mature and the user is underage */
  MatureAge = 'mature_age',
  /** deviation is marked as strict mature and the user is underage */
  StrictMatureAge = 'strict_mature_age',
  /** deviation is marked as mature and the user is logged out */
  MatureLoggedOut = 'mature_loggedout',
  /** current user has blocked this deviation */
  DeviationBlocked = 'deviation_blocked',
  /** current user has the artist of this deviation blocked */
  ArtistBlocked = 'artist_blocked',
  /** the author of this deviation has blocked the current user */
  BlockedByArtist = 'blocked_by_artist',
  /** the deviation is marked as antisocial and the user is logged out */
  Antisocial = 'antisocial',
  /** deviation is marked as nsfg */
  Nsfg = 'nsfg',
}
